module.exports = "/_next/static/images/ed0931b827f88fd59084f3c425df3df9-roxinho-basicos-flutuantes-xs@2x.png";